// Pulled from Shopify's Dawn (https://github.com/Shopify/dawn/blob/64952383e78eae6f73ccb2abcd3a7614f2f5b5a2/assets/global.js#L692)
// Some functionality has been removed for simplicity

class DeferredMedia extends HTMLElement {
  constructor() {
    super()

    this.createObserver()
    this.querySelector('.js-play')?.addEventListener('click', () => {
      this.togglePlayPause();
    })
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        // If the element is visible
        if (entry.isIntersecting) {
          this.loadContent()
        }
      })
    })

    observer.observe(this)
  }

  loadContent(focus = true) {
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div')
      content.appendChild(
        this.querySelector('template').content.firstElementChild.cloneNode(true)
      )

      this.setAttribute('loaded', true)
      const deferredElement = this.appendChild(
        content.querySelector('video, model-viewer, iframe')
      )
      if (focus) deferredElement.focus()
      if (
        deferredElement.nodeName == 'VIDEO' &&
        deferredElement.getAttribute('autoplay')
      ) {
        // force autoplay for safari
        deferredElement.play()
      }
    }
  }

  pauseAllVideos() {
    document.querySelectorAll('deferred-media video').forEach((video) => {
      video.pause();
      video.closest('deferred-media')?.querySelector('.js-play')?.classList.remove('is-playing');
    });
  }

  playAllVideos() {
    document.querySelectorAll('video').forEach((video) => {
      video.play();
      video.closest('deferred-media')?.querySelector('.js-play')?.classList.add('is-playing');
    });
  }

  togglePlayPause() {
    const video = this.querySelector('video');
    if (video.paused) {
      this.playAllVideos();
    } else {
      this.pauseAllVideos();
    }
  }
}

customElements.define('deferred-media', DeferredMedia)
